import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { CreditNoteTypeBadgeProps } from "./CreditNoteTypeBadge.types"

const icon = faIcon({ name: "money-bill-transfer", style: "regular" })

export default function CreditNoteTypeBadge(props: CreditNoteTypeBadgeProps) {
    const { type, size = "md" } = props

    // Only shown when the credit note has a type.
    if (!type) {
        return null
    }

    // e.g. "Type\nPre-Payment".
    const tooltip = `Type\n${type}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {type}
        </Badge>
    )
}
